export function index(jobId) {
    return axios.get(route('api.manage.jobs.interimJobs', {jobId}))
        .then(response => response.data);
}


export function shareJobWithInterims(jobId, data) {
    return axios.post(route('api.manage.jobs.interimJobs.store', {jobId}), data)
        .then(response => response.data);
}

export function shareJobsWithInterim(interimId, data) {
    return axios.post(route('api.manage.interims.interimJobs.store', {interimId}), data)
        .then(response => response.data);
}
